import React, { useState } from 'react';
import { Field, inputClass } from './BackgroundFields';

export default function PaddingFields({ props, onChange }) {
  const [advanced, setAdvanced] = useState(false);
  const p = props || {};

  const set = (key, value) => onChange({ ...p, [key]: value });

  return (
    <div className="rounded-lg border border-border p-3 space-y-3 bg-muted/10">
      <p className="text-xs font-semibold text-foreground">Espacement interne (padding)</p>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Horizontal (px)">
          <input
            type="number"
            min={0}
            max={200}
            className={inputClass}
            value={p.paddingX ?? 0}
            onChange={(e) => set('paddingX', Number(e.target.value) || 0)}
          />
        </Field>
        <Field label="Vertical (px)">
          <input
            type="number"
            min={0}
            max={200}
            className={inputClass}
            value={p.paddingY ?? 0}
            onChange={(e) => set('paddingY', Number(e.target.value) || 0)}
          />
        </Field>
      </div>
      <button
        type="button"
        className="text-xs text-primary hover:underline"
        onClick={() => setAdvanced((v) => !v)}
      >
        {advanced ? 'Masquer le padding avancé' : 'Padding par côté…'}
      </button>
      {advanced && (
        <div className="grid grid-cols-2 gap-3 pt-1">
          <Field label="Haut (px)">
            <input
              type="number"
              min={0}
              className={inputClass}
              value={p.paddingTop ?? ''}
              placeholder={String(p.paddingY ?? 0)}
              onChange={(e) =>
                set('paddingTop', e.target.value === '' ? null : Number(e.target.value) || 0)
              }
            />
          </Field>
          <Field label="Bas (px)">
            <input
              type="number"
              min={0}
              className={inputClass}
              value={p.paddingBottom ?? ''}
              placeholder={String(p.paddingY ?? 0)}
              onChange={(e) =>
                set('paddingBottom', e.target.value === '' ? null : Number(e.target.value) || 0)
              }
            />
          </Field>
          <Field label="Gauche (px)">
            <input
              type="number"
              min={0}
              className={inputClass}
              value={p.paddingLeft ?? ''}
              placeholder={String(p.paddingX ?? 0)}
              onChange={(e) =>
                set('paddingLeft', e.target.value === '' ? null : Number(e.target.value) || 0)
              }
            />
          </Field>
          <Field label="Droite (px)">
            <input
              type="number"
              min={0}
              className={inputClass}
              value={p.paddingRight ?? ''}
              placeholder={String(p.paddingX ?? 0)}
              onChange={(e) =>
                set('paddingRight', e.target.value === '' ? null : Number(e.target.value) || 0)
              }
            />
          </Field>
        </div>
      )}
    </div>
  );
}
